import { format, parseISO, isSameDay } from 'date-fns'
import { es } from 'date-fns/locale'

const formatAmPm = (date: Date): string => {
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const ampm = hours >= 12 ? 'p.m.' : 'a.m.'
  const hours12 = hours % 12 || 12
  const minutesStr = minutes.toString().padStart(2, '0')
  return `${hours12}:${minutesStr} ${ampm}`
}

export const formatVersionDateRange = (
  first: string | null | undefined,
  last: string | null | undefined,
  t: (key: string, options?: Record<string, unknown>) => string
): { dateText: string; timeText: string } => {
  if (!first || !last) {
    return { dateText: '', timeText: '' }
  }

  const start = parseISO(first)
  const end = parseISO(last)

  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return { dateText: '', timeText: '' }
  }

  const sameDay = isSameDay(start, end)
  const sameTime = start.getTime() === end.getTime()

  const dateText = sameDay
    ? format(start, 'dd/MM/yyyy', { locale: es })
    : `${format(start, 'dd/MM/yyyy', { locale: es })} ${t('dashboard.storePerformance.executedTo')} ${format(end, 'dd/MM/yyyy', { locale: es })}`

  const timeText = sameTime
    ? formatAmPm(start)
    : `${formatAmPm(start)} ${t('dashboard.storePerformance.executedToTime')} ${formatAmPm(end)}`

  return { dateText, timeText }
}
